import { sanitize } from 'dompurify'
import { confidenceLevels } from 'Components/SharedComponents/Surveys/constants'
import { snakeCaseToSpaces, toTitleCase } from 'Utils/formatters'
import {
  PriorityContainer,
  PriorityDetail,
  PriorityDetails,
  PriorityHeader,
  PriorityReviewContainer,
} from '../CheckInSurvey.styled'
import { PartialUserSurvey } from '../types'

type PriorityReviewProps = {
  userSurvey: PartialUserSurvey
}

export const PriorityReview = ({ userSurvey }: PriorityReviewProps) => {
  if (!userSurvey) return null

  const priorities = userSurvey.UserSurveyPriority.filter((p) => !p.archivedAt)
  const prioritiesList = priorities
    .sort((a, b) => a.rank - b.rank)
    .map((priority, i) => {
      const confidenceLevel = confidenceLevels.find(
        (c) => c.value === priority.confidenceLevel
      )
      const confidenceLevelLabel = confidenceLevel
        ? confidenceLevel.label
        : 'Not found'

      const headerLabels = ['First', 'Second', 'Third']
      const header = `${headerLabels?.[i] || 'Your'} priority`
      return (
        <PriorityContainer key={priority.id}>
          <PriorityHeader>{header}</PriorityHeader>
          <PriorityDetails>
            <PriorityDetail>
              <strong>Category:&nbsp;</strong>
              {toTitleCase(snakeCaseToSpaces(priority.category))}
            </PriorityDetail>
            {priority.customPriorities && (
              <PriorityDetail>
                <strong>Custom priorities:&nbsp;</strong>
                {sanitize(priority.customPriorities)}
              </PriorityDetail>
            )}
            {priority.UserSurveyPriorityTopic.map((pt, ptIndex) => (
              <PriorityDetail key={pt.id}>
                <strong>
                  {ptIndex > 0 ? 'Additional focus' : 'Focus '} area:&nbsp;
                </strong>{' '}
                {pt.topic}
              </PriorityDetail>
            ))}
            <PriorityDetail>
              <strong>Confidence level:&nbsp;</strong>
              {confidenceLevelLabel}
            </PriorityDetail>
          </PriorityDetails>
        </PriorityContainer>
      )
    })

  return <PriorityReviewContainer>{prioritiesList}</PriorityReviewContainer>
}
